// src/pages/Grow/Intakes/index.tsx
/**
 * `/Grow/Intakes`: the public course-registration intake queue, admin only.
 *
 * Thin shell over `Components/IntakesListView`, matching the `Counselling/Requests` layout.
 */
import IntakesListView from './Components/IntakesListView';

export default function IntakesPage() {
  return <IntakesListView />;
}
